(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function start(stack) {
    if (stack.fsRotateStarted) return;
    stack.fsRotateStarted = true;
    if (reduceMotion || saveData) return;

    var dataEl = stack.querySelector('script[data-fs-stack-items]');
    if (!dataEl) return;
    var items;
    try {
      items = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var tiles = Array.prototype.slice.call(stack.querySelectorAll('.fs-stack__tile'));
    if (!tiles.length || items.length <= tiles.length) return;

    var minWait = Number(stack.getAttribute('data-min')) || 1;
    var maxWait = Number(stack.getAttribute('data-max')) || 2;
    if (maxWait < minWait) maxWait = minWait;

    var shown = {};
    var warmed = {};
    var bag = [];
    var lastTile = null;
    var pointer = 0;
    var timer = null;
    var onScreen = true;
    var stopped = false;
    var observer = null;

    tiles.forEach(function (tile) {
      shown[tile.getAttribute('data-idx')] = true;
      tile.addEventListener('pointerenter', function () { tile.fsHover = true; });
      tile.addEventListener('pointerleave', function () { tile.fsHover = false; });
      tile.addEventListener('focusin', function () { tile.fsHover = true; });
      tile.addEventListener('focusout', function () { tile.fsHover = false; });
    });

    function pickTile() {
      var ok = tiles.filter(function (t) {
        return t.offsetParent !== null && !t.fsHover;
      });
      if (!ok.length) return null;
      bag = bag.filter(function (t) { return ok.indexOf(t) !== -1; });
      if (!bag.length) {
        bag = ok.slice().sort(function () { return Math.random() - 0.5; });
        if (bag.length > 1 && bag[0] === lastTile) bag.push(bag.shift());
      }
      lastTile = bag.shift();
      return lastTile;
    }

    function nextIndex() {
      for (var n = 0; n < items.length; n++) {
        var i = pointer;
        pointer = (pointer + 1) % items.length;
        if (!shown[i]) return i;
      }
      return -1;
    }

    function warm() {
      for (var k = 0; k < 3; k++) {
        var item = items[(pointer + k) % items.length];
        if (item && !warmed[item.s]) {
          warmed[item.s] = true;
          var preload = new Image();
          preload.src = item.s;
        }
      }
    }

    function swap(tile, index) {
      var item = items[index];
      var img = new Image();
      img.alt = '';
      img.width = 480;
      img.height = 480;
      img.className = 'fs-stack__img fs-stack__img--incoming';
      img.src = item.s;
      var ready = img.decode ? img.decode() : new Promise(function (resolve, reject) {
        img.onload = resolve;
        img.onerror = reject;
      });
      return ready.then(function () {
        if (stopped) return;
        var current = tile.querySelector('.fs-stack__img:not(.fs-stack__img--incoming)');
        var label = tile.querySelector('.fs-stack__label');
        tile.insertBefore(img, label);
        void img.offsetWidth;
        img.classList.add('is-in');
        tile.classList.add('is-swapping');
        delete shown[tile.getAttribute('data-idx')];
        shown[index] = true;
        tile.setAttribute('data-idx', index);
        setTimeout(function () {
          if (label) label.textContent = item.l;
          tile.setAttribute('href', item.u);
          tile.classList.remove('is-swapping');
        }, 300);
        setTimeout(function () {
          if (current && current.parentNode) current.parentNode.removeChild(current);
          img.classList.remove('fs-stack__img--incoming', 'is-in');
        }, 900);
      }).catch(function () {});
    }

    function schedule() {
      if (stopped) return;
      var wait = (minWait + Math.random() * (maxWait - minWait)) * 1000;
      timer = setTimeout(tick, wait);
    }

    function tick() {
      if (stopped) return;
      if (onScreen && !document.hidden) {
        var tile = pickTile();
        var index = nextIndex();
        if (tile && index > -1) {
          warm();
          swap(tile, index);
        }
      }
      schedule();
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      });
      observer.observe(stack);
    }

    stack.fsRotateStop = function () {
      stopped = true;
      clearTimeout(timer);
      if (observer) observer.disconnect();
    };

    timer = setTimeout(tick, 1500);
  }

  function startAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-fs-rotate]'), start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startAll(); });
  } else {
    startAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    startAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var stack = event.target.querySelector('[data-fs-rotate]');
    if (stack && stack.fsRotateStop) stack.fsRotateStop();
  });
})();